module.exports = __webpack_public_path__ + "media/book_sound.5486b885.wav";